import { Error, ErrorTargets } from '../../../models/response';

export enum ServerErrorCodes {
  InternalServerError = 'InternalServerError',
  NotImplemented = 'NotImplemented',
  BadGateway = 'BadGateway',
  ServiceUnavailable = 'ServiceUnavailable',
  GatewayTimeout = 'GatewayTimeout',
}

export declare namespace ServerError {
  type ErrorTypes = InternalServerError | NotImplemented | BadGateway | ServiceUnavailable | GatewayTimeout;

  type ErrorWrapper = {
    error: ErrorTypes;
  };

  /* Unexpected condition encountered by the server */
  type InternalServerError = Error<500, ServerErrorCodes.InternalServerError, ErrorTargets.Server>;

  /* The HTTP method sent is not supported by the server */
  type NotImplemented = Error<501, ServerErrorCodes.NotImplemented, ErrorTargets.Server>;

  /* Server overloaded or server firewall functioning improperly */
  type BadGateway = Error<502, ServerErrorCodes.BadGateway, ErrorTargets.Server>;

  /* Server temporaly down */
  type ServiceUnavailable = Error<503, ServerErrorCodes.ServiceUnavailable, ErrorTargets.Server>;

  /* Slow communication to the server */
  type GatewayTimeout = Error<504, ServerErrorCodes.GatewayTimeout, ErrorTargets.Server>;
}
